// js/common/search/search-drawer.js
var SearchWrapper = class extends HTMLElement {
    connectedCallback() {
        this.activeInputBar = document.querySelector("#ds-header-active-search-bar");
        this.passiveInputBar = this.querySelector("#ds-header-search-bar");
        this.hiddenSearchBar = document.querySelector("#mega-menu-search .search-input input")
        this.megaMenuSearch = document.querySelector("#mega-menu-search");
        this.searchBar == null;
        this.cancelButtons = document.querySelectorAll(".ds-search-cancel");
        this.clearButton = document.querySelector("button[type='reset']");
        this.overlay = document.getElementById("ds-overlay")
        
        this.initPassiveInput();
        this.initButtons();
        this.initInputBar();
    }
    
    initButtons(){
        this.cancelButtons.forEach(button => button.addEventListener("click", (event) => {
            this.toggleSearchBar();
            this.overlay.style.display = "none";
        }))
        if (this.overlay) {
            this.overlay.addEventListener("click", (event) => {
                if( this.searchBar.classList.contains("active")){
                    this.toggleSearchBar();
                }
            })
        }
        /*const merchantIcon = document.querySelector(".ds-merchant-link");
        if (merchantIcon) {
            merchantIcon.addEventListener("click", (event) => {
                this.toggleSearchBar();
            })
        }*/

        if(this.clearButton) {
            this.clearButton.addEventListener("click", (event) => {
                const inputEvent = new Event('input', { bubbles: true, cancelable: true });
                this.hiddenSearchBar.value = ""
                this.hiddenSearchBar.dispatchEvent(inputEvent);
            })
        }
    }
    
    initPassiveInput (){
        this.passiveInputBar.addEventListener("click", (event) => {
            event.preventDefault();
            this.toggleSearchBar();
        })
        this.passiveInputBar.addEventListener("submit", (event) => {
            event.preventDefault();
        })
    }

    initInputBar() {
        const inputEvent = new Event('input', { bubbles: true, cancelable: true });
        this.activeInputBar.addEventListener("input", () => {
          this.hiddenSearchBar.value = this.activeInputBar.value;
          this.hiddenSearchBar.dispatchEvent(inputEvent);
        });
        this.activeInputBar.addEventListener("click", () => {
            this.hiddenSearchBar.dispatchEvent(inputEvent);
        });
        this.activeInputBar.addEventListener("submit", (event) => {
            event.preventDefault();
        })
    }

    toggleSearchBar() {
        this.searchBar = document.querySelector(".header__wrapper.search-menu");
        this.searchBar.classList.toggle("active");

        const overlay = document.getElementById("ds-overlay")
        if (overlay) {
            overlay.style.display = "block";
        }

        if(this.megaMenuSearch) {
            if(this.megaMenuSearch.style.display == "block") {
                this.megaMenuSearch.style.display = "none";
            }
            else{
                this.activeInputBar.focus();
                this.megaMenuSearch.style.display = "block";
            }
        }
        //Toggle body scroll
         document.body.classList.toggle("lock");
         //document.querySelector("main").classList.toggle("lock");
    }
    
};
if (!window.customElements.get("search-wrapper")) {
    window.customElements.define("search-wrapper", SearchWrapper);
}